import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BlogSidebar from "../BlogSidebar/BlogSidebar.js";
import { format } from "timeago.js";
import "./BlogList.scss";
import { getEvent } from "../../api/blogs";
import { getProducts } from "../../api/product.js";
import StarLoader from "../loader/StarLoader.js";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const BlogList = (props) => {
  const [events, setEvents] = useState([]);
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 2;
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    async function fetchDatas() {
      try {
        const [eventData, productData] = await Promise.all([
          getEvent(),
          getProducts(),
        ]);
        if (isMounted) {
          setEvents(eventData);
          setProducts(productData);
        }
      } catch (err) {
        console.error("Error fetching events:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchDatas();

    return () => {
      isMounted = false;
    };
  }, []); // ✅ only once on mount

  if (loading) return <StarLoader />;

  if (!events || events.length === 0) {
    return (
      <p style={{ textAlign: "center", padding: "50px" }}>No events found.</p>
    );
  }

  const totalPages = Math.ceil(events.length / perPage);
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentBlogs = events.slice(indexOfFirst, indexOfLast);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  // base button style for pagination and read-more
  const buttonBase = {
    background: "linear-gradient(90deg, darkblue 0%, #4da3ff 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 14px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontWeight: "500",
    boxShadow: "0 4px 10px rgba(0, 0, 139, 0.3)",
  };

  // disabled button style
  const disabledButtonStyle = {
    ...buttonBase,
    background: "linear-gradient(90deg, #a0b8ff 0%, #cce0ff 100%)",
    opacity: 0.7,
    cursor: "not-allowed",
    boxShadow: "none",
  };

  return (
    <section
      className="wpo-blog-pg-section section-padding"
      style={{
        backgroundColor: "#E6F7FF",
        paddingTop: "40px", // reduce vertical padding
        paddingBottom: "40px", // reduce vertical padding
      }}
    >
      <div className="container">
        <div className="row">
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-blog-content">
              {currentBlogs.map((blog, bitem) => (
                <div
                  className="post format-standard-image"
                  key={bitem}
                  style={{
                    border: "1px solid rgba(0, 0, 139, 0.2)",
                    padding: "0px",
                    marginBottom: "30px",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 10px rgba(0, 0, 139, 0.1)",
                    transition: "all 0.3s ease",
                    borderRadius: "20px",
                    width: "90%",
                  }}
                >
                  <div
                    className="entry-media video-holder"
                    style={{
                      boxShadow: "0 2px 6px rgba(0, 0, 139, 0.3)",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={`${apiUrl}/storage/` + blog.banner}
                      alt=""
                      style={{
                        width: "100%",
                        height: "200px", // ✅ reduce image height
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </div>

                  <div
                    className="entry-meta"
                    style={{
                      padding: "0px 20px",
                    }}
                  >
                    <ul>
                      <li>
                        <i className="fi flaticon-calendar"></i>
                        {format(blog.created_at)}
                      </li>
                    </ul>
                  </div>

                  <div
                    className="entry-details"
                    style={{
                      padding: "0px 20px 30px 20px",
                    }}
                  >
                    <h3>
                      <Link
                        onClick={ClickHandler}
                        to={`/event-single/${blog.id}`}
                        style={{
                          color: "#000",
                          textDecoration: "none",
                          transition: "color 0.3s ease",
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "blue")}
                        onMouseLeave={(e) => (e.target.style.color = "#000")}
                      >
                        {blog.eventName}
                      </Link>
                    </h3>

                    <p
                      dangerouslySetInnerHTML={{
                        __html: blog.description,
                      }}
                    />

                    <Link
                      onClick={ClickHandler}
                      to={`/event-single/${blog.id}`}
                      style={{
                        ...buttonBase,
                        display: "inline-block",
                        textDecoration: "none",
                        marginTop: "10px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background =
                          "linear-gradient(90deg, #001f6b 0%, #66b2ff 100%)";
                        e.target.style.boxShadow =
                          "0 6px 16px rgba(0, 0, 139, 0.5)";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background =
                          "linear-gradient(90deg, darkblue 0%, #4da3ff 100%)";
                        e.target.style.boxShadow =
                          "0 4px 10px rgba(0, 0, 139, 0.3)";
                        e.target.style.transform = "translateY(0)";
                      }}
                    >
                      READ MORE
                    </Link>
                  </div>
                </div>
              ))}

              {/* Pagination */}
              {totalPages > 1 && (
                <div
                  className="pagination-wrapper pagination-wrapper-left"
                  style={{ marginTop: "30px" }}
                >
                  <ul
                    className="pg-pagination"
                    style={{
                      display: "flex",
                      gap: "8px",
                      listStyle: "none",
                      padding: 0,
                    }}
                  >
                    {/* Prev */}
                    <li>
                      <button
                        onClick={() =>
                          currentPage > 1 && handlePageChange(currentPage - 1)
                        }
                        disabled={currentPage === 1}
                        style={
                          currentPage === 1 ? disabledButtonStyle : buttonBase
                        }
                        onMouseEnter={(e) => {
                          if (!e.target.disabled) {
                            e.target.style.background =
                              "linear-gradient(90deg, #001f6b 0%, #66b2ff 100%)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.target.disabled) {
                            e.target.style.background =
                              "linear-gradient(90deg, darkblue 0%, #4da3ff 100%)";
                          }
                        }}
                      >
                        <i className="fi ti-angle-left"></i>
                      </button>
                    </li>

                    {/* Page Numbers */}
                    {Array.from({ length: totalPages }, (_, i) => (
                      <li key={i + 1}>
                        <button
                          onClick={() => handlePageChange(i + 1)}
                          style={{
                            ...buttonBase,
                            background:
                              currentPage === i + 1
                                ? "linear-gradient(90deg, #001f6b 0%, #66b2ff 100%)"
                                : "linear-gradient(90deg, darkblue 0%, #4da3ff 100%)",
                            transform:
                              currentPage === i + 1
                                ? "translateY(-2px)"
                                : "none",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background =
                              "linear-gradient(90deg, #001f6b 0%, #66b2ff 100%)";
                          }}
                          onMouseLeave={(e) => {
                            if (currentPage !== i + 1)
                              e.target.style.background =
                                "linear-gradient(90deg, darkblue 0%, #4da3ff 100%)";
                          }}
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}

                    {/* Next */}
                    <li>
                      <button
                        onClick={() =>
                          currentPage < totalPages &&
                          handlePageChange(currentPage + 1)
                        }
                        disabled={currentPage === totalPages}
                        style={
                          currentPage === totalPages
                            ? disabledButtonStyle
                            : buttonBase
                        }
                        onMouseEnter={(e) => {
                          if (!e.target.disabled) {
                            e.target.style.background =
                              "linear-gradient(90deg, #001f6b 0%, #66b2ff 100%)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.target.disabled) {
                            e.target.style.background =
                              "linear-gradient(90deg, darkblue 0%, #4da3ff 100%)";
                          }
                        }}
                      >
                        <i className="fi ti-angle-right"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <BlogSidebar
            blLeft={props.blLeft}
            events={events}
            currentBlogs={currentBlogs}
            products={products}
          />
        </div>
      </div>
    </section>
  );
};

export default BlogList;
